import { Injectable, inject, signal, effect } from '@angular/core';

import { NotificationStore, ToastNotification } from './notification-store.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationScheduler {
  private store = inject(NotificationStore);
  
  // The effective state the UI observes
  private _activeToasts = signal<ToastNotification[]>([]);
  readonly activeToasts = this._activeToasts.asReadonly();
  
  private readonly MAX_VISIBLE = 5;
  private isScheduled = false;

  constructor() {
    // Reactive orchestration: watch the raw queue and schedule flushes
    effect(() => {
      const raw = this.store.queue();
      this.scheduleFlush(raw);
    });
  }

  private scheduleFlush(raw: ToastNotification[]) {
    if (this.isScheduled) return;

    this.isScheduled = true;

    // Microtask scheduling batches multiple updates in the same execution tick
    queueMicrotask(() => {
      this.processQueue(raw);
      this.isScheduled = false;
    });
  }

  private processQueue(raw: ToastNotification[]) {
    // Backpressure: Only show the most recent X toasts
    // This ensures UI stability during notification bursts
    const processed = [...raw]
      .sort((a, b) => b.timestamp - a.timestamp)
      .slice(0, this.MAX_VISIBLE);

    this._activeToasts.set(processed);
  }
}
